<template>
<div>
</div>
</template>

<script>
import { IntegrationGateway } from "@integrations/gatewayIntegrator";

import { mapState, mapMutations } from "vuex";

if(Config.popIntegrationName) {
  var listener = require('@integrations/' + Config.popIntegrationName + '/' + Config.popIntegrationName + 'ListenerSLv1.js');
}
export default {
  name: "PopClientComponent",
  props: ['parameters'],
  data() {
    return {
      gateway: null,
      autoSpinStarted: false,
    };
  },
  mounted() {
    if(Config.popIntegrationName) {
      this.gateway = new IntegrationGateway(Config.popIntegrationName, this.parameters, listener);
      this.setIntegrationGateway(this.gateway);
      this.gateway.loadIntegration();
    }
  },
  computed: {
    ...mapState(['reelSpinning', 'autoSpins'])
  },
  methods: {
    ...mapMutations(['setIntegrationGateway'])
  },
  watch: {
    reelSpinning(newValue, oldValue) {
      if (this.gateway) {
        if ((oldValue && !newValue) && this.gateway.isGamePaused()) {
          this.gateway.sendPauseNotification();
        }
      }
    },
    autoSpins(newValue, oldValue) {
      if (this.gateway) {
        if (oldValue === 0 && newValue > 1 && !this.autoSpinStarted)  {
          this.autoSpinStarted = true;
          this.gateway.startAutoPlay();
        }

        if (newValue === 0 && this.autoSpinStarted) {
          this.autoSpinStarted = false;
          this.gateway.stopAutoPlay();
        }
      }
    }
  }
}
</script>

<style scoped>

</style>